export default "__VITE_ASSET__W6DQfdjX__"